module.exports = {
	"ha": "fha",
	"id": 6.1,
	"report": {
		"ha": "Fraser Health",
		"group": "HSDA",
		"period": "2021 Q1–2022 Q4",
		"lastYear": "2022",
		"lastQuarter": "4"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 680,
			"height": 400,
			"marginLeft": 100,
			"marginRight": 180,
			"marginBottom": 80,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 100px;\">Figure 6.1</span>                 <span style=\"display: table-cell;\">PCS Components for Fraser Health, 2021 Q1–2022 Q4 <sup style=\"font-size: 10px;\">10</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4"
				]
			},
			{
				"linkedTo": 0,
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2021",
					"2021",
					"2021",
					"2021",
					"2022",
					"2022",
					"2022",
					"2022"
				],
				"tickPositions": [
					0,
					4
				]
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 5,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "Percentage",
					"reserveSpace": false,
					"x": -90
				}
			}
		],
		"series": [
			{
				"name": "<3 CD4 Tests",
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"data": [
					25.581395348837212,
					24.444444444444443,
					28.947368421052634,
					34.285714285714285,
					31.03448275862069,
					34.375,
					31.428571428571427,
					{
						"y": 30.303030303030305,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 5,
							"style": {
								"color": "#0076a3",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\"><3 CD4 Tests</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "<3 Viral Load Tests",
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"data": [
					4.651162790697675,
					8.88888888888889,
					13.157894736842104,
					20,
					17.24137931034483,
					15.625,
					14.285714285714285,
					{
						"y": 9.090909090909092,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 15,
							"style": {
								"color": "#9d0140",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\"><3 Viral Load Tests</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "No Baseline Genotype",
				"pointPlacement": "on",
				"color": "#ab9f01",
				"dashStyle": "Solid",
				"data": [
					6.976744186046512,
					8.88888888888889,
					5.263157894736842,
					8.571428571428571,
					6.896551724137931,
					6.25,
					5.714285714285714,
					{
						"y": 6.0606060606060606,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 3,
							"style": {
								"color": "#ab9f01",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">No Baseline Genotype</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "Baseline CD4 <200/µL",
				"pointPlacement": "on",
				"color": "#2b7025",
				"dashStyle": "Solid",
				"data": [
					9.30232558139535,
					8.88888888888889,
					18.421052631578945,
					25.71428571428571,
					37.93103448275862,
					34.375,
					28.57142857142857,
					{
						"y": 21.21212121212121,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": -10,
							"style": {
								"color": "#2b7025",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Baseline CD4 <200/µL</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "Non-Recommended ART",
				"pointPlacement": "on",
				"color": "#560054",
				"dashStyle": "Solid",
				"data": [
					41.86046511627907,
					60,
					65.78947368421053,
					82.85714285714286,
					68.96551724137932,
					71.875,
					77.14285714285715,
					{
						"y": 78.78787878787878,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 0,
							"style": {
								"color": "#560054",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Non-Recommended ART</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "Non Viral Suppression at 9 Mo.",
				"pointPlacement": "on",
				"color": "#9d070d",
				"dashStyle": "Solid",
				"data": [
					30.23255813953488,
					33.33333333333333,
					44.73684210526316,
					40,
					48.275862068965516,
					53.125,
					48.57142857142857,
					{
						"y": 42.42424242424242,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#9d070d",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Non Viral Suppression at 9 Mo.</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "n=",
				"visible": false,
				"pointPlacement": "on",
				"color": "#231f20",
				"dashStyle": "Solid",
				"data": [
					43,
					45,
					38,
					35,
					29,
					32,
					35,
					{
						"y": 33,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#231f20",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">n=</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			}
		]
	},
	"callback": "C:\\git\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_fha_6_1.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_fha_6_1.json
// module id = 207
// module chunks = 0